export const getUrlSearchParams = (params: string, query: string) => {
  return new URLSearchParams(params).get(query) ?? '';
};
